import { Segment, Segments } from './segments.model';

SegmentsController.$inject = ['$scope', '$translate', '$mdDialog', 'company', 'scenarios', 'surveyScenarios', 'redirectedFromAudience', 'SegmentsFactory',
  'AlertingFactory', 'ConfirmationFactory', 'TopToolbarFactory', 'AngularOptinsService', 'uuid', 'AngularCustomFieldsService'];
export function SegmentsController($scope, $translate, $mdDialog, company, scenarios, surveyScenarios, redirectedFromAudience, SegmentsFactory,
  AlertingFactory, ConfirmationFactory, TopToolbarFactory, AngularOptinsService, uuid, AngularCustomFieldsService) {

  $scope.editSegment = editSegment;
  $scope.deleteSegment = deleteSegment;
  $scope.addSegment = addSegment;
  $scope.save = save;
  $scope.enableSave = enableSave;

  init();

  function editSegment(index, event, isNew) {
    enableSave();
    $mdDialog.show({
      'controller': 'SegmentEditionController',
      'template': require('./segment-edition.dialog.html'),
      'targetEvent': event,
      'clickOutsideToClose': false,
      'locals': {
        'dropdownItems': $scope.dropdownItems,
        'segment': angular.copy($scope.segments[index])
      }
    })
      .then(function (modifiedSegment) {
        $scope.config.updateSegment(index, modifiedSegment);
      },
        () => {
          // Case of cancelling the edition dialog after creating a new segment
          if (isNew) {
            $scope.config.deleteSegment(index);
          }
        });
  }

  function deleteSegment(index) {
    ConfirmationFactory.materialConfirmDialog('segments/confirm-deletion')
      .then(function () {
        enableSave();
        $scope.config.deleteSegment(index);
      });
  }

  function addSegment(event) {
    enableSave();
    $scope.config.addSegment(new Segment(uuid.v4(), $translate.instant('segments/edition/default-title')));
    editSegment($scope.segments.length - 1, event, true);
  }

  function save() {
    SegmentsFactory.updateSegments(company.id, $scope.config)
      .then(() => {
        AlertingFactory.success('segments/update-success');
        disableSave();
      }, AlertingFactory.httpErrorHandler()
      );
  }

  function enableSave() {
    TopToolbarFactory.updateButtonDisable(false, $scope);
  }

  function disableSave() {
    TopToolbarFactory.updateButtonDisable(true, $scope);
  }

  function init() {
    TopToolbarFactory.setButton('save', save, $scope);
    disableSave();
    $scope.dropdownItems = {
      languages: [],
      scenarios: [],
      surveyScenarios: [],
      optins: [],
      customFields: [],
    };
    AngularCustomFieldsService.getFields()
      .subscribe({
        next: (customFields) => {
          AngularOptinsService.getOptins()
            .subscribe({
              next: res => {
                $scope.dropdownItems = SegmentsFactory.buildDropdownItems(company.tags_groups[0].tags, scenarios, surveyScenarios, res, customFields);
                SegmentsFactory.getSegments(company.id)
                  .then(response => {
                    const isNewConfig = Object.keys(response.data).length === 0;
                    response.data.segments.forEach(segment => {
                      segment.id = segment.id ? segment.id : uuid.v4();
                    });
                    $scope.config = isNewConfig ? new Segments() : Segments.fromBackEnd(response.data);
                    $scope.segments = $scope.config.segments;

                    if (redirectedFromAudience) {
                      addSegment();                 // Show new segment modal when redirected from audience page
                    }
                  }, AlertingFactory.httpErrorHandler());
              }
            });
        }
      });
  }
}
